import { styled } from 'styled-components';

import { typography } from '@/styles/helpers';

export const ScTooltipMobile = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;

  top: 0;
  left: 0;
  overflow: hidden auto;
  -webkit-overflow-scrolling: touch;
`;

export const ScTooltip = styled.div`
  z-index: 3;

  border-radius: 24px;
  padding: 24px;
  box-sizing: border-box;

  top: 50%;
  left: 50%;

  position: static;
  margin: auto;

  & .contentContainer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 358px;
    height: 471px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;

    & .background {
      position: absolute;
      z-index: 2;
    }

    @media (max-width: 365px) {
      width: 304px;
      height: 400px;

      .background {
        width: 304px;
        height: 400px;
      }
    }
  }

  & .content {
    position: relative;
    text-align: center;
    padding: 32px 0;
    width: 100%;
    color: ${({ theme }) => theme.whiteColor};
    gap: 8px;
    z-index: 4;
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: center;

    .title {
      ${typography['body1bold']}
    }
    .largeTitle {
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
    }
    .body {
      ${typography['body1regular']}
      @media (max-width: 365px) {
        ${typography['body2regular']}
      }
    }
    .terms {
      ${typography['caption1regular']}
    }
    .image {
      margin-bottom: 8px;
    }

    .activeImg {
      @media (max-width: 365px) {
        display: none;
      }
    }
  }

  & .smallGap {
    gap: 4px;
  }

  & .ctaButton {
    position: relative;
    z-index: 4;
    width: 100%;
  }

  .telegramOrWhatsappBtns {
    position: relative;
    z-index: 4;
    display: flex;
    gap: 6px;

    button {
      min-width: 144px;
      font-size: 14px;
    }
  }

  & .closeBtn {
    top: 40px;
    right: 32px;
    z-index: 5;
  }
`;
